export const UserManagementTooltip = {
  init: () => {
    // Select all elements with the class 'user-management-tooltip'
    const tooltipElements = document.querySelectorAll('.user-management-tooltip')
    tooltipElements.forEach((tooltip) => {
      // Find the tooltip text within the current tooltip element
      const tooltipText = tooltip.querySelector('.user-management-tooltip-text')
      if (tooltipText) {

        // Add event listeners for mouse enter and leave
        tooltip.addEventListener('mouseenter', () => {
          console.log('1')
          tooltipText.classList.add('show-tooltip')
        })

        tooltip.addEventListener('mouseleave', () => {
          console.log('2')
          tooltipText.classList.remove('show-tooltip')
        })
      }
    })
  },
}
